import React from 'react';
import PropTypes from 'prop-types';
import MappedAgentSelect from './MappedAgentSelect';

const ModalUserIntegrations = ({
  integrationAgentsMap,
  mappedAgentOnChange,
  mappedUserIntegrations,
  validationErrors,
  vendorMapping = {},
} = {}) => {
  return mappedUserIntegrations.map((mappedUserIntegration) => {
    const { vendor, vendor_property_id } = mappedUserIntegration;
    const agents = integrationAgentsMap[vendor_property_id];
    const validationError = validationErrors[vendor_property_id];
    const vendorName = vendorMapping[vendor] || '';

    return (
      <div className="leasing-team-mapping" key={vendor_property_id}>
        <div className="modal-field-label">
          <label className="required" htmlFor={vendor_property_id}>
            <strong>
              {`${vendorName} Mapping ( ID: ${vendor_property_id} ) `}
            </strong>
          </label>
        </div>
        <div className="modal-field-input">
          <MappedAgentSelect
            agents={agents}
            key={mappedUserIntegration.mapped_agent_id}
            mappedAgentOnChange={mappedAgentOnChange}
            mappedUserIntegration={mappedUserIntegration}
            selectElementId={vendor_property_id}
          />

          {validationError && (
            <div className="knock-react-form-hint-error">{validationError}</div>
          )}
        </div>
      </div>
    );
  });
};
ModalUserIntegrations.propTypes = {
  integrationAgentsMap: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    )
  ),
  mappedAgentOnChange: PropTypes.func,
  mappedUserIntegrations: PropTypes.arrayOf(
    PropTypes.shape({
      mapped_agent_id: PropTypes.number,
      mapped_username: PropTypes.string,
      property_id: PropTypes.number,
      vendor: PropTypes.string,
      vendor_property_id: PropTypes.string,
    })
  ),
  validationErrors: PropTypes.objectOf(PropTypes.string),
  vendorMapping: PropTypes.objectOf(PropTypes.string),
};

export default ModalUserIntegrations;
